// extracted by mini-css-extract-plugin
export default {"container":"fS-z","modal":"gS-z","dimensions":"hS-z","brandName":"iS-z","productName":"jS-z","labelValue":"kS-z","recipientEmail":"lS-z","recommendedFit":"mS-z","hiddenField":"nS-z"};